import React, { useState, useEffect } from 'react';
import DashboardHeader from '../components/common/DashboardHeader';
import ReservationForm from '../components/ReservationForm';
import { Box, Paper } from '@mui/material';
import { detectThemeSync, watchThemeChanges } from '../utils/themeUtils';
import { getDashboardPageShellSx, resolveDashboardThemeMode } from '../utils/dashboardSurfaceSx';
import { isMobileShellLayout } from '../utils/mobileShellLayout';

/**
 * Reservation Page
 * Desktop: header + paper shell. Mobile shell: form owns layout (walk-in pattern).
 */
const ReservationPage = () => {
  const [currentTheme, setCurrentTheme] = useState(() => detectThemeSync());
  const isDark = resolveDashboardThemeMode(currentTheme) === 'dark';
  const isMobileLayout = isMobileShellLayout();

  useEffect(() => {
    const cleanup = watchThemeChanges((newTheme) => {
      setCurrentTheme(newTheme);
    });
    return cleanup;
  }, []);

  if (isMobileLayout) {
    return (
      <Box sx={getDashboardPageShellSx(currentTheme)}>
        <ReservationForm />
      </Box>
    );
  }

  return (
    <Box
      sx={{
        p: { xs: 2, sm: 3 },
        backgroundColor: isDark ? '#12151c' : '#f2f4f7',
        minHeight: '100vh',
        transition: 'background-color 0.3s ease',
      }}
    >
      <Box sx={{ mb: 3 }}>
        <DashboardHeader
          title="Reservation"
          breadcrumbs={[
            { label: 'Home', path: '/dashboard/' },
            { label: 'Booking', path: '/booking/' },
            { label: 'Reservation' },
          ]}
          navLinks={[
            { url: '/booking/dashboard/', label: 'Booking Dashboard' },
            { url: '/booking/list/', label: 'Booking List' },
            { url: '/finance/rates/', label: 'Manage Rate' },
          ]}
        />
      </Box>

      <Paper
        elevation={0}
        sx={{
          p: { xs: 2, sm: 3, md: 4 },
          backgroundColor: isDark ? '#2a2a31' : '#ffffff',
          border: `1px solid ${isDark ? '#333246' : '#e0e0e0'}`,
          borderRadius: 2,
          transition: 'background-color 0.3s ease, border-color 0.3s ease',
        }}
      >
        <ReservationForm />
      </Paper>
    </Box>
  );
};

export default ReservationPage;
